export enum JointEnum {
// Brustwirbelsäule
  Brustwirbelsaeule = 'Brustwirbelsaeule',

  // Halswirbelsäule
  Halswirbelsaeule = 'Halswirbelsaeule',

  // Lendenwirbelsäule
  Lendenwirbelsaeule = 'Lendenwirbelsaeule',

  // Schultergelenk
  Schultergelenk = 'Schultergelenk',

  // Kniegelenk
  Kniegelenk = 'Kniegelenk',

  // Sprunggelenk
  Sprunggelenk = 'Sprunggelenk',
}
